module.exports = __webpack_public_path__ + "static/media/2_en.7911fa6c.png";